// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plant-solid';

export const Component = () => (
  <path d='M12.637 13.457h.047v5.22c1.39.144 2.539.72 3.496 1.725.91 1.005 1.39 2.25 1.39 3.64v.478H6.794v-.479c0-1.389.479-2.634 1.436-3.64.91-1.005 2.06-1.58 3.449-1.724V11.59c0-1.15.383-2.156 1.101-3.066.72-.861 1.677-1.436 2.826-1.676.527-.096 1.437-.096 2.73 0 1.293.143 2.49.143 3.592.047 1.102-.047 1.916-.382 2.538-1.005 0 1.915-.766 3.88-2.25 5.843-1.533 1.963-3.4 2.97-5.604 2.97h-.143c-1.39 0-2.635-.432-3.832-1.246Zm-1.916-.718c0-1.82-.287-3.352-.814-4.598-.527-1.245-1.198-2.203-1.963-2.825a22.563 22.563 0 0 0-2.3-1.628c-.766-.432-1.436-.958-1.963-1.581A3.054 3.054 0 0 1 2.867 0c-.862.862-1.484 2.49-1.82 4.838C1 5.028 1 5.316 1 5.748c0 1.772.623 3.352 1.82 4.645 1.196 1.293 2.682 2.06 4.453 2.203 1.198.096 2.347.144 3.449.144Z' />
);

export const viewBox = '0 0 25 25';
